module.exports = __webpack_public_path__ + "img/premio-box-icon-soci.e4c63d34.png";